import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import authReducer from './auth/auth.reducer';
import activeTabReducer from './active-tabs/active-tab.reducer';
import percentageReducer from './phone-percentage/percentage.reducer';

const persistConfig = {
  key: 'RingerV2',
  storage,
};

const rootReducer = combineReducers({
  authReducer: authReducer,
  activeTabReducer: activeTabReducer,
  percentageReducer: percentageReducer,
});

export default persistReducer(persistConfig, rootReducer);
